<template>
  <div class="tipslista__kort-info">
    <div class="tipslista__kort-header-wrapper">
      <div class="leftColumn">
        <a
          v-if="tips.LankMaterial"
          :href="tips.LankMaterial"
          target="_blank"
          class="tipslista__kort-lank preventAutomaticIcon"
        >
          <h3 class="tipslista__kort-rubrik">{{ tips.Rubrik }}</h3>
          <svg-icon icon-name="extern-lank" />
          <span class="sr-only">, öppna i ny flik</span>
        </a>
        <h3 v-else class="tipslista__kort-rubrik">{{ tips.Rubrik }}</h3>

        <div class="tipslista__kort-taggar">
          <span class="sr-only">Taggar för tipset, </span>
          <div class="tipslista__kort-taggar--nyckelord">
            <span v-for="tag in tips.Nyckelord" :key="tag.Name" :class="{ vald: tag.Chosen }">
              <svg-icon v-if="tag.Chosen" icon-name="check" />
              {{ tag.Name }}
            </span>
          </div>
          <div class="tipslista__kort-taggar--typ">
            <span v-for="tag in tips.Typer" :key="tag.Name" :class="{ vald: tag.Chosen }">
              <svg-icon v-if="tag.Chosen" icon-name="check" />
              {{ tag.Name }}
            </span>
          </div>
        </div>
      </div>

      <div v-if="showShare && tips.Id > 0 && tips.DelningsUrl" class="share-wrapper">
        <button
          type="button"
          class="btn btn-default content-id"
          :data-id="tips.Id"
          @click.stop="$emit('toggle-share')"
        >
          <svg-icon icon-name="dela" />
          <span class="btn-text">Dela</span>
        </button>
        <div
          :style="isShareOpen ? { display: 'block' } : {}"
          class="link-modal"
          role="dialog"
          :aria-labelledby="`modal_label-${tips.Id}`"
          aria-modal="true"
          :id="`modal-${tips.Id}`"
          @click.stop
          @mouseup.stop
        >
          <h3 :id="`modal_label-${tips.Id}`">Dela</h3>
          <div class="input-wrapper">
            <label :for="`input-${tips.Id}`" class="sr-only">Länk för att dela resurs</label>
            <input
              :id="`input-${tips.Id}`"
              type="text"
              class="form-control"
              readonly
              :value="tips.DelningsUrl"
            />
            <button type="button" class="btn btn-default copyurl" @click.stop="$emit('copy-url')">
              Kopiera
            </button>
          </div>
          <div v-if="isCopied" class="message" style="display: block">
            <p role="status"><svg-icon icon-name="check" /> Länken är kopierad</p>
          </div>
        </div>
      </div>
    </div>

    <div class="tipslista__kort-framtagare">
      <span class="tipslista__kort-fettext">Vem har tagit fram materialet:</span> {{ tips.Framtagare }}
    </div>
    <div><span class="tipslista__kort-fettext">Inkommet:</span> {{ tips.InskickadDatumTid }}</div>
    <div class="tipslista__kort-ingress">
      <span class="sr-only">Kortare beskrivning av tipset, </span>
      {{ tips.Ingress }}
    </div>
  </div>

  <div class="tipslista__kort-knapp">
    <button
      type="button"
      class="btn btn-default"
      :aria-expanded="isExpanded ? 'true' : 'false'"
      :aria-label="isExpanded ? 'Dölj längre beskrivning om tipset' : 'Visa längre beskrivning om tipset'"
      @click="isExpanded = !isExpanded"
    >
      <span class="btn-text">{{ isExpanded ? 'Visa mindre' : 'Visa mer' }}</span>
      <svg-icon icon-name="triangel-pil-ned" />
    </button>
  </div>

  <div :class="isExpanded ? 'collapse in' : 'collapse'">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="tipslista__kort-beskrivning" v-html="tips.Beskrivning"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import SvgIcon from '../components/svgicon.vue';
import { TipsItemDto } from './hittaTipsSidaService';

export default defineComponent({
  name: 'HittaTipsSidaKort',
  components: { SvgIcon },
  props: {
    tips: { type: Object as PropType<TipsItemDto>, required: true },
    isShareOpen: { type: Boolean, default: false },
    isCopied: { type: Boolean, default: false },
    showShare: { type: Boolean, default: false },
  },
  emits: ['toggle-share', 'copy-url'],
  setup(props) {
    const isExpanded = ref(props.tips.MarkeratTips ?? false);
    return { isExpanded };
  },
});
</script>
